import { render } from "./FormKitBasicDemo.vue?vue&type=template&id=1d46e408"
import script from "./FormKitBasicDemo.vue?vue&type=script&lang=js"
export * from "./FormKitBasicDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__